import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { QRCodeModule } from 'angularx-qrcode';

@Component({
  selector: 'megastore-admin-invoice',
  templateUrl: './invoice.component.html',
  styleUrls: ['./invoice.component.scss'],
  standalone: true,
  imports: [CommonModule, QRCodeModule, TranslateModule]
})
export class InvoiceComponent {
  updatedData: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { data: string; type: string }
  ) {
    this.updatedData = JSON.stringify(data);
  }

  printQRCode(): void {
    const printContents = document.getElementById('qrCodeElement')?.innerHTML;
    const popupWindow = window.open('', '_blank', 'width=600,height=600');
    if (popupWindow) {
      popupWindow.document.open();
      popupWindow.document.write(`
      <html>
        <head>
          <title>Print QR Code</title>
          <style>
            @media print {
              body {
                -webkit-print-color-adjust: exact;
              }
            }
          </style>
        </head>
        <body onload="window.print();window.close()">
          ${printContents}
        </body>
      </html>
    `);
      popupWindow.document.close();
    }
  }
}
